import React, { useState } from 'react';
import { FaPlay, FaPause, FaSun, FaMoon, FaCoins, FaHome, FaBars, FaLinkedin, FaGithub, FaDesktop } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';

export default function Header({ isPlaying, togglePlay, darkMode, toggleTheme, score }) {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="header-dictionary">
            <div className="heading-dictionary">
                <h1>WORDWAVE</h1>
            </div>
            <button className="home-button" onClick={() => navigate('/')}>
                <FaHome />
            </button>
            <button className="music-button" onClick={togglePlay}>
                {isPlaying ? <FaPause /> : <FaPlay />}
            </button>
            <button className="theme-button" onClick={toggleTheme}>
                {darkMode ? <FaSun /> : <FaMoon />}
            </button>
            <div className="score">
                <FaCoins />
                <span>{score}</span>
            </div>
            <button className="menu-button" onClick={toggleMenu}>
                <FaBars />
            </button>
            {isMenuOpen && (
                <div className="burger-menu">
                    <div className="about-me-menu">
                        <h2>👩🏽‍💻 About Me</h2>
                        <p>Coded by Karine.</p>
                        <img src='https://media0.giphy.com/media/tHcAr9ethx9FDfyOQT/giphy.gif?cid=6c09b952qkjgbj7tfh1hw1uyztgy8ckb8ytk7clwtuea9hu1&ep=v1_internal_gif_by_id&rid=giphy.gif&ct=s' alt="Dolphin GIF"
          className="dolphin-gif"/>
                    </div>
                    <div className="social-media-links-menu">
                        <a href="https://www.linkedin.com/in/karine-magalhaes-heidgerken-3836911a7/" target="_blank" rel="noopener noreferrer">
                            <FaLinkedin />
                        </a>
                        <a href="https://github.com/Kamagalhaes92" target="_blank" rel="noopener noreferrer">
                            <FaGithub />
                        </a>
                        <a href="https://karine-magalhaes.netlify.app/" target="_blank" rel="noopener noreferrer">
                            <FaDesktop />
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
